import { render, staticRenderFns } from "./ExtendedProfile.vue?vue&type=template&id=36857602&"
import script from "./ExtendedProfile.vue?vue&type=script&lang=js&"
export * from "./ExtendedProfile.vue?vue&type=script&lang=js&"
import style0 from "./ExtendedProfile.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports